module.exports = __webpack_public_path__ + "img/respawn_dragon.1b41de8c.gif";